export default {
  forceOpenCookiesMainBanner: false,
  isCookieEnabled: false,
};
